<div class="rcm-panel__body">
  <ng-container *ngIf="detail">
    <div novaCard variant="secondary" class="rcm-panel__card">
      <div novaCardContent>
        <p class="rcm-panel__card-title">Notary status</p>
        <p
          class="rcm-panel__row"
          *ngFor="let row of notaryRows; trackBy: trackByRowLabel"
        >
          {{ row.label }}:
          <span class="rcm-panel__value">{{ row.value }}</span>
        </p>
      </div>
    </div>

    <div novaCard variant="secondary" class="rcm-panel__card">
      <div novaCardContent>
        <p class="rcm-panel__card-title">Client status</p>
        <div
          class="rcm-panel__group"
          *ngFor="let group of clientGroups; trackBy: trackByGroupIndex"
        >
          <p
            class="rcm-panel__row"
            *ngFor="let row of group; trackBy: trackByRowLabel"
          >
            {{ row.label }}:
            <span class="rcm-panel__value">{{ row.value }}</span>
          </p>
        </div>
      </div>
    </div>

    <div novaCard variant="secondary" class="rcm-panel__card">
      <div novaCardContent>
        <p class="rcm-panel__card-title">Closing info</p>
        <p
          class="rcm-panel__row"
          *ngFor="let row of closingRows; trackBy: trackByRowLabel"
        >
          {{ row.label }}:
          <span class="rcm-panel__value">{{ row.value }}</span>
        </p>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="showLoading">
    <div
      novaCard
      variant="secondary"
      class="rcm-panel__card rcm-panel__card--skeleton"
      *ngFor="let card of skeletonCards; trackBy: trackByIndex"
      aria-hidden="true"
    >
      <div novaCardContent>
        <div
          novaSkeleton
          variant="text"
          [hasAnimation]="true"
          class="rcm-panel__skeleton-title"
          [style.width]="card.titleWidth"
        ></div>
        <div
          novaSkeleton
          variant="text"
          [hasAnimation]="true"
          class="rcm-panel__skeleton-row"
          *ngFor="let width of card.rowWidths; trackBy: trackByIndex"
          [style.width]="width"
        ></div>
      </div>
    </div>
  </ng-container>

  <div class="rcm-panel__actions" *ngIf="actions.length > 0">
    <button
      novaButton
      variant="secondary"
      size="small"
      type="button"
      class="rcm-panel__action"
      *ngFor="let action of actions; trackBy: trackByActionLabel"
      [disabled]="action.disabled"
    >
      <nova-icon
        *ngIf="action.icon"
        [name]="action.icon"
        size="small"
      ></nova-icon>
      {{ action.label }}
    </button>
  </div>
</div>

<div class="rcm-panel__error" *ngIf="errorMessage" role="alert">
  <nova-icon name="error" size="small" class="rcm-panel__error-icon"></nova-icon>
  <span class="rcm-panel__error-text">{{ errorMessage }}</span>
  <button
    novaButton
    variant="secondary"
    size="small"
    type="button"
    class="rcm-panel__action rcm-panel__retry"
    [disabled]="retrying"
    (click)="retry.emit()"
  >
    {{ retrying ? "Retrying…" : "Retry" }}
  </button>
</div>
